import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { PermissionsService } from '../services/permissions.service';

// Gates the /settings/permissions admin page. Checks the cached corporate-permissions flag
// list for PermissionsAdmin or SuperAdmin — same source the rest of the app uses for admin
// gating. Bounces non-admins to the dashboard rather than showing a 403 page, matching the
// pattern in organizationAccessGuard.
export const permissionsAdminGuard: CanActivateFn = () => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);

  return permissionsService.isPermissionsAdmin$().pipe(
    take(1),
    map(allowed => {
      if (allowed) return true;
      router.navigate(['']);
      return false;
    })
  );
};
